import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import IndividualCounselling from './pages/services/IndividualCounselling';
import ChildAdolescentTherapy from './pages/services/ChildAdolescentTherapy';
import CorporateWellness from './pages/services/CorporateWellness';
import SchoolsCollegesWellness from './pages/services/SchoolsCollegesWellness';
import SeminarsWorkshops from './pages/services/SeminarsWorkshops';
import Packages from './pages/Packages';
import Contact from './pages/Contact';
import Footer from './components/Footer';
import SessionBookingForm from './components/SessionBookingForm';
import ComingSoon from './components/ComingSoon';
import { Toaster } from 'react-hot-toast';
import TherapyDetails from './pages/TherapyDetails';
import Booking from './pages/Booking';
import PrivacyPolicy from './pages/Privacy';
import TermsAndConditions from './pages/Terms&Conditions';
import CancellationPolicy from './pages/CancellationPolicy';
import WhatsAppChat from './components/WhatsAppChat';
import ClientDashboard from './pages/ClientDashboard';
import ClientAuth from './pages/ClientAuth';
import ClientLanding from './pages/ClientLanding';
import ClientOnboarding from './pages/ClientOnboarding';

function AppContent() {
  const { pathname } = useLocation();
  const isClientPortal = pathname === '/login'
    || pathname === '/reset-password'
    || pathname === '/client'
    || pathname.startsWith('/client/');

  return (
    <div className={`min-h-screen ${isClientPortal ? 'bg-[#f3faf9]' : 'bg-[#f8fcfc]'}`}>
      {!isClientPortal && <Navbar />}
      <Toaster position="top-right" reverseOrder={false} />
      <div className="w-full">
        <Routes>
          <Route path="/login" element={<ClientAuth />} />
          <Route path="/reset-password" element={<ClientAuth />} />
          <Route path="/client" element={<ClientLanding />} />
          <Route path="/client/onboarding" element={<ClientOnboarding />} />
          <Route path="/client/dashboard" element={<ClientDashboard />} />
          <Route path="/client/mood" element={<ClientDashboard />} />
          <Route path="/client/journal" element={<ClientDashboard />} />
          <Route path="/client/chat" element={<ClientDashboard />} />
          <Route path="/client/library" element={<ClientDashboard />} />
          <Route path="/client/booking" element={<ClientDashboard />} />
          <Route path="/client/profile" element={<ClientDashboard />} />
          <Route path="/client/:section" element={<Navigate to="/client/dashboard" replace />} />
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:therapyId" element={<TherapyDetails />} />
          <Route path="/services/counselling/individual-counselling" element={<IndividualCounselling />} />
          <Route path="/services/counselling/child-adolescent-therapy" element={<ChildAdolescentTherapy />} />
          <Route path="/services/wellness/corporate-wellness" element={<CorporateWellness />} />
          <Route path="/services/wellness/schools-colleges-wellness" element={<SchoolsCollegesWellness />} />
          <Route path="/services/wellness/seminars-workshops" element={<SeminarsWorkshops />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/individual-therapy" element={<SessionBookingForm />} />
          <Route path="/couples-therapy" element={<SessionBookingForm />} />
          <Route path="/family-therapy" element={<ComingSoon />} />
          <Route path="/group-therapy" element={<ComingSoon />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/terms&conditions" element={<TermsAndConditions />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/refund-policy" element={<CancellationPolicy />} />
        </Routes>
      </div>
      {!isClientPortal && <WhatsAppChat />}
      {!isClientPortal && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
